var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-box"},[_c('div',{staticClass:"py-12"},[_c('div',{staticClass:"text-center",attrs:{"id":"center"}},[_c('h1',{staticClass:"error-title error--text"},[_vm._v("404")]),_c('h3',{staticClass:"text-uppercase error-subtitle"},[_vm._v("¡NO SE ENCONTRÓ LA PÁGINA!")]),_c('p',{staticClass:"text-muted mt-4 mb-4"})])])])
}]

export { render, staticRenderFns }